import { axios } from "../api";
import { User } from "../users/user-management/types";
import { DueDateDetailView, DueDateLinkedRecord } from "./type";

export type DueDateStatusLabelLookup = (
  status: number | string | null | undefined
) => string;

export function createDueDateStatusLabelLookup(
  dueDateConfig: { status?: Record<number, string> } | null | undefined,
  fallbackStatus?: string
): DueDateStatusLabelLookup {
  return (recordStatus) => {
    if (typeof recordStatus === "number" && dueDateConfig?.status) {
      return (
        dueDateConfig.status[recordStatus]?.toUpperCase() ??
        String(recordStatus)
      );
    }
    if (typeof recordStatus === "string" && recordStatus) {
      return recordStatus.toUpperCase();
    }
    if (typeof fallbackStatus === "string" && fallbackStatus) {
      return fallbackStatus.toUpperCase();
    }
    return recordStatus != null ? String(recordStatus) : "";
  };
}

export async function fetchDueDatePdfContext(
  duedateId: number,
  statusLabelFor: DueDateStatusLabelLookup
) {
  const [duedateResp, linkedRecordsResp] = await Promise.all([
    axios.get<DueDateDetailView>(`/v6/duedate/${duedateId}`, {
      id: `get-duedate-${duedateId}`,
    }),
    axios.get<DueDateLinkedRecord[]>(
      `/v6/duedate/linked_records/${duedateId}`,
      {
        id: `get-duedate-linked-records-${duedateId}`,
      }
    ),
  ]);

  return buildDueDatePdfContext(
    duedateResp.data.last_done,
    linkedRecordsResp.data,
    statusLabelFor
  );
}

export const mapDueDateLinkedRecordForPdf = (
  record: DueDateLinkedRecord,
  statusLabelFor: DueDateStatusLabelLookup
) => ({
  last_done: record.last_done ?? "",
  due_date: record.required ?? record.due_date ?? "",
  status: statusLabelFor(record.status),
  title: record.title ?? "",
  section: record.section?.name ?? "",
  type_id: record.type_obj?.name ?? "",
  created_by: record.user_obj?.gecos ?? "",
  company_id: record.company_obj?.name ?? "",
  comment: record.comment ?? "",
});

export const buildDueDatePdfContext = (
  reportDate: string | Date | null | undefined,
  linkedRecords: DueDateLinkedRecord[],
  statusLabelFor: DueDateStatusLabelLookup
) => ({
  report_date: reportDate ?? "",
  lines: linkedRecords.map((record) =>
    mapDueDateLinkedRecordForPdf(record, statusLabelFor)
  ),
});

export const formtListObject = (data:User[])=>{
    console.log(data,"dataa")
    const formatedData = data.map((obj)=>{
        return {
            "contact_id" : obj.id,
            "contact_type":"user",
        }
    })
    return formatedData
}

type DueDateFilterSpec = {
  field: string;
  op: string;
  value: unknown;
  model?: string;
};

const DATE_TYPE_TO_COLUMN: Record<string, string> = {
  required: "required",
  last_done: "last_done",
  begin_date: "begin_date",
};

/** Map advanced-search UI fields to real whiteboard columns before list API call. */
export function transformDueDateListParams(
  params: Record<string, unknown>
): Record<string, unknown> {
  const rawFilters = params.filter;
  if (!Array.isArray(rawFilters) || rawFilters.length === 0) {
    return params;
  }

  const parsed: DueDateFilterSpec[] = rawFilters.map((item) =>
    typeof item === "string" ? JSON.parse(item) : item
  );

  let dateType = "";
  let dateFrom: string | null = null;
  let dateTo: string | null = null;
  const kept: DueDateFilterSpec[] = [];

  for (const spec of parsed) {
    if (spec.field === "date_type") {
      if (spec.value != null && spec.value !== "") {
        dateType = String(spec.value);
      }
      continue;
    }
    if (spec.field === "date_from") {
      if (spec.value != null && spec.value !== "") {
        dateFrom = String(spec.value);
      }
      continue;
    }
    if (spec.field === "date_to") {
      if (spec.value != null && spec.value !== "") {
        dateTo = String(spec.value);
      }
      continue;
    }
    kept.push(spec);
  }

  if (dateFrom || dateTo) {
    const dateField =
      DATE_TYPE_TO_COLUMN[dateType || "required"] ?? "required";
    if (dateFrom) {
      kept.push({ field: dateField, op: ">=", value: dateFrom });
    }
    if (dateTo) {
      kept.push({ field: dateField, op: "<=", value: dateTo });
    }
  }

  const next = { ...params };
  if (kept.length > 0) {
    next.filter = kept.map((spec) => JSON.stringify(spec));
  } else {
    delete next.filter;
  }
  return next;
}

